import { Resolutions } from '../common/const';
/**
 * @zoom
 */
export const initZoom = () => {
    $(`body`).on(`click`, `[data-zoom]`, (e) => {
        e.preventDefault();
        e.stopPropagation();
    });

    $(`[data-fancybox="gallery"]`).fancybox({
        animationEffect: `zoom-in-out`,
        clickContent: `close`,
        buttons: [`close`],
        loop: true,
        thumbs: {
            autoStart: true
        },
        slideShow: {
            autoStart: false,
            transitionEffect: false,
        },
        btnTpl: {
            arrowLeft:
                `<button data-fancybox-prev class="fancybox-button fancybox-button--arrow_left" title="{{PREV}}">` +
                `<svg class="icon icon--left icon--big"><use xlink:href="#left"></use></svg>` +
                `</button>`,
            arrowRight:
                `<button data-fancybox-next class="fancybox-button fancybox-button--arrow_right" title="{{NEXT}}">` +
                `<svg class="icon icon--right icon--big"><use xlink:href="#right"></use></svg>` +
                `</button>`,
            close:
                `<button data-fancybox-close class="fancybox-button fancybox-button--close" title="{{CLOSE}}">` +
                `<svg class="icon icon--close"><use xlink:href="#close"></use></svg>` +
                `</button>`,
        },
        beforeShow(instance, el) {
            instance.$refs.container.addClass(`zoom`);

            instance.$refs.container.find(`.fancybox-thumbs__list a`).each((i, el) => {
                $(el).css(`background-image`, `url(${instance.group[i].src})`);
            });
        },
        beforeClose(instance) {
            // if (!sliders.prod_detail.el.classList.contains(`disabled`)) sliders.prod_detail.slider.slideTo(instance.currIndex, 0);
        },
    });

    function onResize() {
        if (Resolutions.IS_DP()) {
            $(`[data-fancybox="gallery"]`).off(`click`);

            $(`.active [data-zoom]`).each((i, el) => {
                $(el).zoom({ url: $(el).attr(`href`) });
            });

        } else {
            $(`[data-zoom]`).trigger(`zoom.destroy`);
        }
    }

    // onResize();
    // isWidthResize(onResize);
};

